import { parseYearAndQuarter } from '..';

/**
 * @param input a string like '2021 Q3' or '2020Q3'. The space is optional.
 * @returns a string that always includes a space between the year and quarter, like '2021 Q3', or
 * null if the input cannot be parsed.
 */
export const formatYearAndQuarter = (input: string): Maybe<string> => {
    const yearAndQuarter = parseYearAndQuarter(input);

    if (yearAndQuarter === null) {
        return null;
    }

    return `${yearAndQuarter.year} Q${yearAndQuarter.quarter}`;
};
